import { render, staticRenderFns } from "./searchBox.vue?vue&type=template&id=8772d0da&scoped=true&"
import script from "./searchBox.vue?vue&type=script&lang=js&"
export * from "./searchBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8772d0da",
  null
  
)

export default component.exports